import { render, staticRenderFns } from "./ITMO.vue?vue&type=template&id=5c25aa20&"
import script from "./ITMO.vue?vue&type=script&lang=js&"
export * from "./ITMO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports